<template>
    <ModalCustom
        :is-open="state.isOpen"
        @close="closeModal"
        title="Select Videos"
    >
        <div class="w-[80vw] max-h-[50vh] overflow-y-auto">
            <loading-circle class="m-12" v-if="state.isLoading" />
            <div v-else>
                <app-select
                    name="video_group_select"
                    v-model="state.selectedVideoGroupId"
                >
                    <option
                        v-for="group in state.videoGroups"
                        :value="group.id"
                        :key="group.id"
                    >
                        {{ group.name }}
                    </option>
                </app-select>
                <div
                    class="
                        my-6
                        grid grid-cols-3
                        gap-4
                        lg:grid-cols-4
                        flex-grow flex-shrink
                    "
                >
                    <div
                        v-if="state.videos.length === 0"
                        class="col-span-4 self-center"
                    >
                        <div class="text-center text-gray-500">
                            No videos found
                        </div>
                    </div>
                    <div
                        v-for="video in state.videos"
                        :key="video.id"
                        class="
                            px-4
                            bg-white
                            shadow-lg
                            rounded-lg
                            border-[1px] border-gray-200
                            text-center
                            cursor-pointer
                        "
                    >
                        <div
                            class="
                                relative
                                group
                                text-sm
                                md:text-base
                                fit-content
                                flex flex-col
                                overflow-hidden
                            "
                        >
                            <div class="block text-md py-1">
                                {{ video.title }}
                            </div>
                            <VideoPlayer
                                :thumbnail="video.thumbnail"
                                :url="video.url"
                            ></VideoPlayer>

                            <button
                                class="
                                    bg-gradient-to-br
                                    from-green-300
                                    to-green-500
                                    text-white
                                    rounded-lg
                                    my-2
                                    mx-auto
                                    w-fit
                                    px-4
                                    py-1
                                "
                                @click="attach(video)"
                            >
                                Attach
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ModalCustom>
</template>
<script setup>
import { defineEmits, reactive, onMounted, defineProps, ref, watch } from "vue";
import emitter from "tiny-emitter/instance";

const state = reactive({
    isOpen: false,
    videos: [],
    videoGroups: [],
    selectedVideoGroupId: "",
    isLoading: false,
});

const props = defineProps({
    isFromModal: Boolean,
});

const teamIdFromUrl = new URLSearchParams(window.location.search).get("teamId");

emitter.on("tiptap-video-modal", (data) => {
    state.isOpen = true;
    if (props.isFromModal) {
        emitter.emit("toggle-thread-modal", false);
    }
});

function closeModal() {
    state.isOpen = false;
    if (props.isFromModal) {
        emitter.emit("toggle-thread-modal", true);
    }
}

function attach(video) {
    emitter.emit("attach-forum-video", video);
    closeModal();
}

watch(
    () => state.selectedVideoGroupId,
    (videoGroupId) => {
        getVideos(videoGroupId);
    }
);

async function getVideoGroups() {
    try {
        state.isLoading = true;
        const teamId = teamIdFromUrl ? teamIdFromUrl : "";
        const resp = await axios.get("/video/groups?teamId=" + teamId);

        if (resp.data.length && resp.data.length > 0) {
            state.videoGroups = resp.data;
            state.selectedVideoGroupId = resp.data[0].id;
            getVideos(state.selectedVideoGroupId);
        }
    } catch (e) {}

    state.isLoading = false;
}

async function getVideos(videoGroupId) {
    try {
        state.isLoading = true;
        const teamId = teamIdFromUrl ? teamIdFromUrl : "";
        const resp = await axios.get(
            `/video/list?teamId=${teamId}&videoGroupId=${videoGroupId}`
        );
        state.videos = resp.data;
    } catch (e) {}
    state.isLoading = false;
}

onMounted(() => {
    getVideoGroups();
});
</script>
